<template>
  <div
    class="start-ups-feature startup-about-feature section-space--pt_120"
    id="about"
  >
    <div class="container">
      <div class="section-title-wrapper text-center section-space--mb_60">
        <h2 class="section-title mb-30 wow move-up font-weight-bold">
          Formación al alcance de todos
        </h2>
        <div
          class="
            elementor-element elementor-element-79f9819
            elementor-widget-divider--view-line
            elementor-widget elementor-widget-divider
          "
          data-id="79f9819"
          data-element_type="widget"
          data-widget_type="divider.default"
        >
          <div class="elementor-widget-container">
            <div class="elementor-divider">
              <span class="elementor-divider-separator"> </span>
            </div>
          </div>
        </div>
      </div>
      <!-- feature component -->
      <opcionesFormacion />
    </div>
  </div>
</template>

<script>
import opcionesFormacion from "@/components/features/opcionesFormacion";
export default {
  components: {
    opcionesFormacion,
  },
};
</script>

<style>
.section-title {
  color: #000;
}

.elementor-widget-container {
  margin: -21px -21px -21px -21px;
}

.elementor-divider {
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  display: flex;
}

.elementor-divider-separator,
.elementor-divider-separator-white {
  width: 70px;
  margin: 0 auto;
}

.elementor-widget-divider:not(.elementor-widget-divider--view-line_text):not(.elementor-widget-divider--view-line_icon)
  .elementor-divider-separator {
  border-top: solid #ffcc0d 9.8px;
}

.elementor-widget-divider:not(.elementor-widget-divider--view-line_text):not(.elementor-widget-divider--view-line_icon)
  .elementor-divider-separator-white {
  border-top: solid #ffffff 9.8px;
}
</style>